export default __webpack_public_path__ + "static/media/051-percentage.9ab3f0fd.svg";